export default __webpack_public_path__ + "static/media/inspect4.6892510e.jpg";